/**
 * Number of characters to truncate x-axis labels to for Fluent VerticalStackedBarChart
 * Used for Buckets, Priority, and Members chart
 */ export const CharsToTruncateXAxisLabels = 5;
/**
 * Maximum number of entities to display in Bar Chart
 * Used for Charts.js charts (Buckets, Priority, and Members chart)
 */ export const MaxDisplayableEntitiesOnBarChart = 25;
/**
 * Maximum number of entities to display in VerticalStackedBarChart
 * Used for Fluent UI charts (Buckets, Priority, and Members chart)
 */ export const MaxDisplayableEntitiesOnFluentBarChart = 10;
/**
 * Maximum bar width for the Fluent VerticalStackedBarChart to prevent excessively wide bars
 * Used for Buckets, Priority, and Members chart
 */ export const MaxBarWidth = 32;
/**
 * Minimum number of characters a user needs to type before a search executes
 */ export const MinCharsNeededToSearch = 2;
/**
 * Time interval in milliseconds between user activity sampling
 */ export const UserActivitySamplingResolutionMs = 60000;
